import { useMutation, useQuery } from "@tanstack/react-query";
import { AuthenticatorBulkBatchToFulfill } from "models/shipping";
import { useAuthenticatedRequest, useAuthenticatedRequestCreator } from "./useRequests";

const useAuthenticatorBulkMissingLabel = (enabled: boolean) => {
    const query = useAuthenticatedRequest<AuthenticatorBulkBatchToFulfill[]>({
        method: "get",
        url: "/shipping/search/ab-missing-label",
    });

    return useQuery(['shipping', 'authenticator-bulk', 'missing-label'], query, { enabled });
}

const useAuthenticatorBulkFulfill = () => {
    const post = useAuthenticatedRequestCreator<
        { labelUrl: string },
        {
            batchId: string,
            length: number,
            width: number,
            height: number,
            weightInLbs: number
        }>(
            (data) => ({
                method: "post",
                url: "/shipping/batches/ab-fulfill",
                data: {
                    ...data,
                    weight: data.weightInLbs * 16
                }
            }), [503]
        );

    const { mutateAsync: fulfill } = useMutation(post);

    return { fulfill };
};

export { useAuthenticatorBulkFulfill, useAuthenticatorBulkMissingLabel };

